'use strict';

class Checkbox extends Widget {
  _element: any;

  constructor(element: any) {
    super(element);
    this._element.click(this._onClick.bind(this));
  }

  checked(value?: any) {
    if (value === undefined) {
      return this._element.hasClass('checked');
    } else if (value !== this.checked()) {
      this._element.toggleClass('checked');
    }
  }

  click() {
    this._element.click();
  }

  _onClick() {
    this.checked(!this.checked());
  }

  static Create() {
    return $('<div class="checkbox" />');
  }
}

ui.Checkbox = Checkbox;
ui.checkbox = ui.widgetConstructor('checkbox', ui.Checkbox);
